import React from 'react';
import { useNavigate } from 'react-router-dom';
/** components **/
import { SurveyLayout } from 'components/organisms';
/** styles **/
import s from '../styles/pages/benefits.module.scss';
/** images **/
import BenefitTitle from 'assets/images/benefit-title.png';
import BenefitImage01 from 'assets/images/benefit-image01.png';
import BenefitImage02 from 'assets/images/benefit-image02.png';
import BenefitImage03 from 'assets/images/benefit-image03.png';
import { ReactComponent as GreenCircleArrow } from 'assets/images/green-circle-arrow.svg';

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="8" fill="#00B66A" />
    <path d="M11.2069 4.79242C11.5975 4.40199 12.2305 4.40193 12.621 4.79242C13.0114 5.18292 13.0114 5.81598 12.621 6.20648L7.63077 11.1957C7.62733 11.1993 7.6245 11.204 7.621 11.2075C7.40112 11.4272 7.10431 11.5233 6.81729 11.4955C6.74267 11.4884 6.66936 11.4706 6.59756 11.4467C6.57778 11.4401 6.55742 11.4351 6.53799 11.4272C6.50748 11.4149 6.47757 11.4007 6.44815 11.3852C6.39024 11.3547 6.33437 11.3185 6.28213 11.2758C6.25593 11.2545 6.23038 11.2309 6.20596 11.2065L6.20499 11.2055L3.37881 8.37836C2.98832 7.98783 2.9883 7.35481 3.37881 6.9643C3.76934 6.57399 4.40242 6.57388 4.79288 6.9643L6.91299 9.08441L11.2069 4.79242Z" fill="white" />
  </svg>
);

export const Benefits: React.FC = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate('/survey/floor-plan', { state: { selectedFloorPlan: '1ldk' } });
  };

  const handleBack = () => {
    navigate('/survey');
  };

  return (
    <SurveyLayout>
      <div className={s.benefitsWrapper}>
        {/* メインコンテンツ */}
        <section className={s.mainContent}>
          <div className={s.titleWrapper}>
            <h2 className={s.mainTitle}>
              P-manならではの<br />
              入居者特典がいっぱい！
            </h2>
            <img src={BenefitTitle} alt="特典" className={s.titleImage} />
          </div>

          <p className={s.leadText}>
            以下をご確認の上、次ページ以降の<br />アンケートにお進みください。
          </p>

          {/* 犬の保育園・常駐ペットシッター */}
          <div className={s.benefitCard}>
            <h3 className={s.benefitTitle}>犬の保育園・常駐ペットシッター</h3>
            <div className={s.benefitList}>
              <div className={s.benefitItem}>
                <CheckIcon />
                <span>犬の保育園</span>
              </div>
              <p className={s.benefitDescription}>
                当日預かり相談可<br />
                ご自宅（お部屋）送迎サービス
              </p>
              <div className={s.benefitItem}>
                <CheckIcon />
                <span>常駐ペットシッター</span>
                <img src={BenefitImage01} alt="常駐ペットシッター" className={s.benefitImageMobile} />
              </div>
              <p className={s.benefitDescription}>
                当日シッティング相談可<br />
                見守りサービス
              </p>
              <div className={s.benefitItem}>
                <CheckIcon />
                <span>ケアサポート</span>
                <img src={BenefitImage02} alt="ケアサポート" className={`${s.benefitImageMobile} ${s.benefitImageMobile2}`} />
              </div>
              <p className={s.benefitDescription}>
                体調不良時等のサポート<br />
                動物病院通院サポート
              </p>
            </div>
          </div>

          {/* そのほかの入居者特典 */}
          <div className={s.benefitCard}>
            <h3 className={s.benefitTitle}>そのほかの入居者特典</h3>
            <div className={s.benefitList}>
              <div className={s.benefitItem}>
                <CheckIcon />
                <span>外部連携・イベント</span>
              </div>
              <p className={s.benefitDescription}>
                病院連携、往診サービス連携<br />
                保育園季節イベント<br />
                出張トリミング（月1〜2）<span className={s.additionalFee}>※別料金</span><br />
                定期ドッグトレーナー<span className={s.additionalFee}>※別料金</span>
              </p>
              <div className={s.benefitItem}>
                <CheckIcon />
                <span>ペットのための共用設備</span>
                <img src={BenefitImage03} alt="ペットのための共用設備" className={`${s.benefitImageMobile} ${s.benefitImageMobile3}`} />
              </div>
              <p className={s.benefitDescription}>
                館内ドッグラン利用※<br />
                共用ペットバス利用
              </p>
              <div className={s.benefitItem}>
                <CheckIcon />
                <span>そのほか</span>
              </div>
              <p className={s.benefitDescription}>
                フードやグッズのお試し<br />
                介護用品等のシェアリング
              </p>
            </div>
          </div>
        </section>

        {/* ナビゲーションボタン */}
        <div className={s.navigationButtons}>
          <button onClick={handleBack} className={s.backButton}>
            戻る
          </button>
          <button onClick={handleNext} className={s.nextButton}>
            <span className={s.buttonText}>進む</span>
            <GreenCircleArrow className={s.buttonIcon} />
          </button>
        </div>
      </div>
    </SurveyLayout>
  );
};